import { IBadgeResource } from "../../badges";
import { EntityTypes } from "../../EntityTypes";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapOrderedRelationAsIRIs, mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillBlock, ISkillBlockResource } from "../types";

export type ISkillBlockPatchMutationParameters = {
    data: {
        title?: string;
        shortTitle?: string;
        rncpId?: string | null;
        skills?: RelationalValue<ISkillResource>[];
        badges?: RelationalValue<IBadgeResource>[];
    };
    skillBlock: RelationalValue<ISkillBlockResource>;
};

export type ISkillBlockPatchMutationResult = ISkillBlock;

export const skillBlockPatchMutation: IApiMutationFunction<ISkillBlockPatchMutationParameters> = ({
    skillBlock,
    data: { title, shortTitle, rncpId, skills, badges },
}) => {
    return {
        method: "PATCH",
        url: `/skill_blocks/${mapRelationalValue(skillBlock)}`,
        data: {
            title,
            shortTitle,
            rncpId,
            skills: mapOrderedRelationAsIRIs(EntityTypes.SKILL, skills),
            badges: mapOrderedRelationAsIRIs(EntityTypes.BADGE, badges),
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useSkillBlockPatchMutation = createApiMutationHook<
    ISkillBlockPatchMutationParameters,
    ISkillBlockPatchMutationResult
>(skillBlockPatchMutation);
